import React, {useEffect, useState} from 'react';

// custom components
import { ImageDictionary, CustomSpinner} from '_atoms';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectAirportInformation, getAirportInformation, selectReviewsStatus} from '_redux/slices/analytics/reviews' 

// tremor
import { Title as TremorTitle, Subtitle, Card } from '@tremor/react';

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// styling
import { Spacing, Colors } from '_styles';

const AirportCheckBox = (props) => {

    const dispatch = useDispatch();

    const airportInformation = useSelector(selectAirportInformation)
    const airportInformationStatus = useSelector(selectReviewsStatus)

    useEffect(() => {
        if(airportInformation[props.iata]){}
        else { dispatch(getAirportInformation(props.iata))}
    }, []);

    return (
        <Row 
            onClick={()=>{props.onClick(props.iata)}}
            style={{ 
                marginTop:Spacing.SCALE_12, 
                marginBottom:Spacing.SCALE_12, 
                cursor:'pointer', 
                borderWidth:0.1, borderStyle:'solid', borderRadius:5, 
                borderColor: props.checked ? Colors.PRM_LIGHT_BLUE : '#ced4da',
                padding:12
            }}>

                {/* Picture */}
                <Col xs={2}>
                    <div 
                        style={{
                            width: '100px',
                            height: '100px',
                            borderRadius: '50%',
                            overflow: 'hidden'
                        }}>
                        <ImageDictionary
                            style={{    
                                display: 'block',
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                objectPosition: 'center'
                            }} 
                            iata={props.iata}
                        />
                    </div>
                </Col>

                {/* Airport Title */}
                <Col className={airportInformationStatus == 'loading' ? 'mt-0' : 'mt-2'}>
                    { airportInformationStatus == 'loading' ? <CustomSpinner rowCenter={true} size={true} /> : 
                    <>
                        <Subtitle>{airportInformation && props.iata != null && airportInformation[props.iata] != undefined ? airportInformation[props.iata].iata : ''}</Subtitle>
                        <div>
                            <TremorTitle>{airportInformation && props.iata != null && airportInformation[props.iata] != undefined ? airportInformation[props.iata].name : ''}</TremorTitle>
                            <Subtitle>{airportInformation && props.iata != null && airportInformation[props.iata] != undefined ? airportInformation[props.iata].locationServed : ''}</Subtitle>
                        </div>
                    </>
                    }
                </Col>

        </Row>
    );
};

export default AirportCheckBox;
